<template>
	<div class="visitor-details">
		<div class="company-row card">
			<client-module>
				<span slot="moduletitle" style="font-size: 20px">公司资料</span>
				<div class="info-wrap">
					<div class="img-wrap">
						<avatar :avatarUrl="resource.logoUrl || logo" size="100" radius="6px"></avatar>
					</div>
					<div class="base-info">
						<p class="company-name">{{ resource.companyName }}</p>
						<page-data-card
							:cardList="cardList"
							labelStyle="width:85px;text-align:right;"
						></page-data-card>
					</div>
					<div class="btn-list">
						<div class="social-list">
							<span
								class="social-item"
								v-for="item in iconList"
								:style="getIconStyle(item)"
								:key="item.icon"
							>
								<ig-icon
									style="font-size: 26px"
									:name="item.icon"
									@click.native="skipTo(item.bind)"
								></ig-icon>
							</span>
						</div>
						<div class="btn-item">
							<el-button type="primary" @click="openWebSearch">网络查询</el-button>
						</div>
					</div>
				</div>
			</client-module>
		</div>

		<div
			class="visitor-detail-list card"
			v-loading="contact_loading"
			element-loading-text="正在查询，请稍等"
			v-if="isUrl"
		>
			<client-module>
				<el-button v-if="!contactQuery" slot="event" type="primary" @click="queryMore"
					>查询更多</el-button
				>
				<span slot="moduletitle" style="font-size: 20px">联系人信息</span>
				<div class="contact-info">
					<!-- 查询 -->
					<div class="contact-query-box" v-if="contactQuery">
						<p style="font-weight: bolder; font-size: 16px">公司联系人查询</p>
						<p>
							当前为您查询到该公司的
							<span style="font-size: 22px; font-weight: bolder">
								{{ filters.filters.thousands(staffNum) }}
							</span>
							个联系人信息，如需查看详细联系人资料，请点击立即查询
						</p>
						<p>
							<el-button type="primary" :loading="query_loading" @click="getVisitorStaff"
								>立即查询</el-button
							>
						</p>
					</div>
					<!-- 列表 -->
					<div class="contact-list" v-if="!contactQuery">
						<sky-tabs
							:tabList="tabList"
							style="border-bottom: 1px solid #e8e8e8; margin-top: 10px"
							v-model="activeTab"
						></sky-tabs>
						<div class="customer-list" v-show="activeTab === 'prospect'">
							<visitor-contact-list
								ref="prospect"
								index="0"
								:visitorId="getId"
								name="prospect"
								@total-records="ontotalRecords"
							></visitor-contact-list>
						</div>
						<div class="email-list" v-show="activeTab === 'email'">
							<visitor-contact-list
								ref="email"
								index="1"
								:visitorId="getId"
								name="email"
								@total-records="ontotalRecords"
							></visitor-contact-list>
						</div>
					</div>
				</div>
			</client-module>
		</div>

		<div class="visitor-detail-list card">
			<client-module :hideBorder="true">
				<span slot="moduletitle" style="font-size: 20px">访问详情</span>
				<div class="data-list-content">
					<data-list
						:table-style="{ name: 'webclient' }"
						:data="data"
						:rowKey="getRowKeys"
						:expandRowKeys="expandRowKeys"
						:columns="column"
						:loading="loading"
						:page="page"
						:page-size="page.pageSize"
						@page-size-changed="pageSizeChanged"
						@page-changed="pageChanged"
						@sort-change="sortChange"
					>
					</data-list>
				</div>
			</client-module>
		</div>
	</div>
</template>

<script>
import clientModule from '@/components/client/clientModule/clientModule';
import avatar from '@/components/avatar/index.vue';
import pageDataCard from '@/components/customPageCard/pageDataCard.vue';
import listPageCreate from '@/mixins/listPageCreate';
import api from '@/backend/apiConfig/apiConfig';
import visitorSiteList from '@/components/setting/visitorSiteList.vue';
import visitorContactList from '@/components/setting/visitorContactList.vue';
import visitorSer from '@/backend/services/visitor/index.js';
import { asyncCatch } from '@/common/util.js';
import openLink from '@/components/tools/open-link.vue';
import filters from '@/mixins/filters.js';
import logo from '@/assets/defaultLogo.png';
import skyTabs from '@/components/iglobalwin/formComponents/tabs/sky-tabs.vue';
const list = listPageCreate({
	searchConfig: {
		api: api.visitor.visitorDetailList,
		method: 'POST',
	},
	getQuery(data, that) {
		return _.assign(data, {
			serviceId: that.getServiceId,
			visitorId: that.getId,
		});
	},
});
export default {
	mixins: [list],
	components: {
		clientModule,
		avatar,
		pageDataCard,
		skyTabs,
		visitorContactList,
	},
	data() {
		return {
			filters,
			contactQuery: true,
			query_loading: false,
			contact_loading: false,
			activeTab: 'prospect',
			staffNum: 0,
			logo,
			cardList: [],
			iconList: [
				{
					icon: 'facebook',
					color: '#3A5998',
					bind: 'facebookUrl',
				},
				{
					icon: 'linkedin',
					color: '#1177B8',
					bind: 'linkedinUrl',
				},
				{
					icon: 'TwitterIcon',
					color: '#04ACF3',
					bind: 'twitterHandle',
				},
			],
			column: [
				{
					label: '',
					type: 'tableExpand',
					width: 60,
					tagName: visitorSiteList,
				},
				{
					label: '时间',
					bind: 'startsAt',
				},
				{
					label: '来源',
					// bind: (row) => {
					//   return `${row.source}/${row.medium || '-'}：${row.campaign || '-'}`
					// },
					bind: 'sourceAndMedium',
					showOverflowTooltip: true,
				},
				{
					label: '访问页数',
					bind: 'pageDepth',
				},
				{
					label: '时长',
					bind: 'visitLengthStr',
				},
			],
			resource: {},
			expandRowKeys: [],
			tabList: [
				{
					label: '潜在客户（0）',
					name: 'prospect',
				},
				{
					label: '邮箱地址（0）',
					name: 'email',
				},
			],
		};
	},
	computed: {
		getId() {
			return this.$route.query.id;
		},
		getServiceId() {
			return this.$route.query.serviceId;
		},
		isUrl() {
			return this.$route.query.isurl;
		},
	},
	watch: {
		data: {
			immediate: true,
			deep: true,
			handler(val) {
				if (val && val.length) {
					this.expandRowKeys = [];
					this.expandRowKeys.push(val[0].id);
				}
			},
		},
	},
	methods: {
		getRowKeys(row) {
			return row.id;
		},
		ontotalRecords(num, id) {
			let mapping = { 0: '潜在客户', 1: '邮箱地址' };
			this.tabList[id].label = `${mapping[id]}（${num}）`;
		},
		async queryMore() {
			this.contact_loading = true;
			let [err, res] = await asyncCatch(visitorSer.visitorStaff, {
				serviceId: this.getServiceId,
				visitorId: this.getId,
			});
			if (res) {
				this.$refs.prospect.query();
				this.$refs.email.query();
			}
			this.contact_loading = false;
		},
		async getVisitorStaff() {
			this.query_loading = true;
			let [err, res] = await asyncCatch(visitorSer.visitorStaff, {
				serviceId: this.getServiceId,
				visitorId: this.getId,
			});
			if (res) {
				this.contactQuery = false;
			}
			this.query_loading = false;
		},
		// 员工统计数
		async getVisitorStaffTotal() {
			this.contact_loading = true;
			let [err, res] = await asyncCatch(visitorSer.visitorStaffTotal, {
				serviceId: this.getServiceId,
				visitorId: this.getId,
			});
			if (res && res.data) {
				this.staffNum = res.data.staffNum;
				// 0:不需要拉取;1:拉取;2:更多拉取(刷新数据);
				this.contactQuery = [1, 2].includes(res.data.pullType);
			}
			this.contact_loading = false;
		},
		getIconStyle(item) {
			if (this.resource && this.resource[item.bind]) return { color: item.color };
			return { cursor: 'not-allowed', color: '#acacac' };
		},
		async getVisitorDetails() {
			let [err, res] = await asyncCatch(visitorSer.visitorDetails, { id: this.getId });
			if (res) {
				this.resource = res.data;
				this.setCardList(res.data);
			}
		},
		setCardList(_data = {}) {
			const getDate = datetime => {
				if (datetime) {
					let date = datetime.split(' ');
					return date.length === 2 ? date[0] : date;
				}
				return '';
			};
			this.cardList = [
				{
					label: '地区',
					value: _data.address,
					col: 12,
				},
				{
					label: '首次访问',
					value: getDate(_data.firstVisitDate),
					col: 12,
				},
				{
					label: '公司网址',
					value: _data.websiteUrl,
					col: 12,
					type: openLink,
				},
				{
					label: '最近访问',
					value: getDate(_data.lastVisitDate),
					col: 12,
				},
				{
					label: '行业',
					value: _data.industry,
				},
				{
					label: '预估员工数',
					value: filters.filters.thousands(_data.employeeCount),
				},
				{
					label: '电话',
					value: _data.phone,
				},
			];
		},

		skipTo(platform) {
			const { resource } = this;
			if (resource && resource[platform]) {
				window.open(resource[platform], '_blank');
			}
		},
		openWebSearch() {
			if (this.resource && this.resource.companyName) {
				let { companyName } = this.resource;
				let url = `https://www.baidu.com/s?ie=utf-8&f=8&wd=${companyName}&cl=3`;
				let _url = window.decodeURIComponent(url);
				window.open(_url, '_blank');
			}
		},
	},
	mounted() {
		this.query();
		this.setCardList();
		this.getVisitorDetails();
		this.isUrl && this.getVisitorStaffTotal();
	},
};
</script>

<style lang="scss">
.visitor-details {
	.card {
		background-color: white;
		box-shadow: 0px 2px 6px 0px #e9ecf8;
		border-radius: 4px;
	}
	.visitor-detail-list {
		margin-top: 20px;
	}
	.info-wrap {
		display: flex;
		padding: 40px 20px 10px;
	}
	.contact-info {
		min-height: 300px;
	}
	.contact-query-box {
		padding: 30px 0 0 0;
		text-align: center;
		line-height: 70px;
	}
	.base-info {
		flex: 1;
		padding-left: 30px;
		.company-name {
			font-size: 22px;
			font-weight: 500;
		}
	}
	.btn-list {
		flex: 1;
		text-align: end;
	}
	.social-list {
		margin-bottom: 34px;
	}
	.social-item {
		margin-left: 11px;
		cursor: pointer;
	}
	.data-list-content {
		padding: 0 20px;
	}
	.custom-page-card {
		padding: 20px 0 !important;
	}
	.el-loading-text {
		font-size: 16px !important;
	}
	.el-loading-spinner {
		font-size: 28px !important;
	}
}
</style>
